import { AxiosResponse } from 'axios';
import { IContaCleanDTO, IContaDTO, IContaFullDTO } from '../models/happy-code-api.model';
import { baseCreate } from './base/base-create.service';
import { baseDelete } from './base/base-delete.service';
import { baseFindById } from './base/base-find-id.service';
import { baseFindList } from './base/base-find-list.service';
import { baseFind } from './base/base-find.service';
import http from '../helpers/http-common';

export const useContaService = () => {
	const resourceURL = '/conta-despesa';

	const createCustom = (body: IContaDTO): Promise<AxiosResponse<IContaDTO>> => http.post(`${resourceURL}/create-custom`, body);
	return {
		...baseCreate<IContaCleanDTO, IContaDTO, IContaFullDTO>(resourceURL),
		...baseFindById<IContaCleanDTO, IContaDTO, IContaFullDTO>(resourceURL),
		...baseFind<IContaCleanDTO, IContaDTO, IContaFullDTO>(resourceURL),
		...baseFindList<IContaCleanDTO, IContaDTO, IContaFullDTO>(resourceURL),
		...baseDelete(resourceURL),
		createCustom,
	};
};
